"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiltersForm = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var files_api_1 = require("@newfront-insurance/files-api");
var react_1 = __importDefault(require("react"));
var document_types_1 = require("../../../lib/document-types");
function FiltersForm(_a) {
    var form = _a.form, onChange = _a.onChange;
    var handleSubmit = form.handleSubmit, values = form.values;
    return (react_1.default.createElement("form", { onSubmit: handleSubmit },
        react_1.default.createElement(core_ui_1.Stack, { gap: 20, direction: "vertical" },
            react_1.default.createElement(core_ui_1.Field, { label: "Filter by document type", fieldId: "documentType" },
                react_1.default.createElement(core_ui_1.AdvancedSelectInput, { isMulti: true, name: "documentTypes", onChange: onChange('documentTypes'), options: document_types_1.DOCUMENT_TYPES_SELECT_OPTIONS, value: values.documentTypes || [], inputId: "documentTypes" })),
            react_1.default.createElement(core_ui_1.SwitchWithLabel, { label: "Hide archived files", enabled: values.fileStatus === files_api_1.FileStatus.ACTIVE, onClick: function (enabled) {
                    var currentStatus = enabled ? files_api_1.FileStatus.ACTIVE : '';
                    form.setFieldValue('fileStatus', currentStatus);
                }, size: "regular" }))));
}
exports.FiltersForm = FiltersForm;
